import React, { useState } from 'react';
import StaffList from './StaffList';
import StaffPayroll from './StaffPayroll';
import StaffLeaves from './StaffLeaves';
import ClassSubjectIncharge from './ClassSubjectIncharge';

const StaffModule = () => {
  const [view, setView] = useState('list');
  return (
    <div>
      <div className="d-flex gap-2 mb-4">
        {[['list','👨‍💼 Staff Directory'], ['classSubject','👨‍💼 Class & Subject Incharge '],['payroll','💰 Payroll'],['leaves','🏖️ Leaves']].map(([k,l]) => (
          <button key={k} className={`btn ${view === k ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setView(k)}>{l}</button>
        ))}
        
      </div>
      {view === 'list' && <StaffList />}
      {view === 'classSubject' && <ClassSubjectIncharge />}
      {view === 'payroll' && <StaffPayroll />}
      {view === 'leaves' && <StaffLeaves />}
    </div>
  );
};
export default StaffModule;
